module.exports = __webpack_public_path__ + "img/Sebastien.39f33cf3.png";